import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./state/store";
import AOS from "aos";
import "aos/dist/aos.css";

import BootstrapVueNext from "bootstrap-vue-next";
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import { vMaska } from "maska";
import VueFeather from "vue-feather";
import VuelidatePlugin from "@vuelidate/core";

import "@/assets/scss/config/galaxy/app.scss";
import "@/assets/scss/mermaid.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "remixicon/fonts/remixicon.css";

AOS.init({
  easing: "ease-out-back",
  duration: 1000,
});

//cek sesion
// store.dispatch("checkSession");

createApp(App)
  .use(store) 
  .use(router) 
  .use(VueApexCharts)
  .use(BootstrapVueNext)
  .use(VuelidatePlugin) 
  .component(VueFeather.type, VueFeather)
  .directive("maska", vMaska)
  .use(vClickOutside)
  .mount("#app");
